<template>

    <div class="mt-3 col-md-3"
        v-if="showProfiles">
        <h3>Select population loader profile:</h3>
        
        <select class="form-select"
            v-model="profile" aria-label="Select Profile">
            <option v-for="item in populationStore.settings"
                :value="item"
                :key="item.ProfileName">
                {{ item.ProfileName }}
            </option>
        </select>
    </div>
</template>
<script setup lang="ts">
import { useAgencyTypeStore } from "@/stores/agencyTypesStore";

import { computed, onMounted, ref, watch } from "vue";

import { usePopulationStore } from "@/stores/populationStore";
import { PopulationProfile } from "@/types";
const emit = defineEmits();
const agencyTypeStore = useAgencyTypeStore();
agencyTypeStore.list();

const populationStore = usePopulationStore();
const profile = ref<PopulationProfile>();
const showProfiles = computed(() => populationStore.settings.length > 1);

onMounted(async () => {
    await populationStore.listSettings();
    profile.value = populationStore.settings[0];
});

watch(profile, (newValue, oldValue) => {
    
    if (showProfiles.value) {
        emit("update:modelValue", profile);
    }
});
</script>